import { render, staticRenderFns } from "./StateAnswerWriting.vue?vue&type=template&id=741a7a98&scoped=true&"
import script from "./StateAnswerWriting.vue?vue&type=script&lang=js&"
export * from "./StateAnswerWriting.vue?vue&type=script&lang=js&"
import style0 from "./StateAnswerWriting.vue?vue&type=style&index=0&id=741a7a98&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "741a7a98",
  null
  
)

component.options.__file = "StateAnswerWriting.vue"
export default component.exports